export const CLEAR_USER_CACHE = 'CLEAR_USER_CACHE';

export interface ClearUserCacheAction {
  type: typeof CLEAR_USER_CACHE;
}
